export function normalizeName(s: string) {
  return s.trim().replace(/\s+/g, ' ');
}

export function normalizeOptional(value?: string | null) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : '';
}

export function slugifyInput(input: string) {
  return normalizeName(input)
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/-{2,}/g, '-');
}

export function slugify(input: string) {
  return slugifyInput(input).replace(/^[-_]+|[-_]+$/g, '');
}

export function isValidOrgName(name: string) {
  const n = normalizeName(name);
  return n.length >= 2 && n.length <= 80;
}

export type SlugValidationResult = {
  valid: boolean;
  error: string | null;
};

const SLUG_REGEX = /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/;

export function validateSlug(slug: string): SlugValidationResult {
  const value = slug.trim();

  if (!value) {
    return { valid: false, error: 'Slug is required.' };
  }

  if (value.length < 3) {
    return { valid: false, error: 'Slug must be at least 3 characters.' };
  }

  if (value.length > 60) {
    return { valid: false, error: 'Slug must be less than 60 characters.' };
  }

  if (!SLUG_REGEX.test(value)) {
    return {
      valid: false,
      error: 'Slug must use lowercase letters, numbers, hyphens, or underscores.',
    };
  }

  return { valid: true, error: null };
}
